import { createContext, useContext, useRef, useMemo } from "react";
import { useQuery, useMutation } from "@tanstack/react-query";
import { udpateTest, addTest, getTestById } from "../../api/testimonial";
import useToaster from "../../components/alert";
import Const from "../../utils/constant";
import { useSearchParams } from "react-router-dom";

const PageContext = createContext();

export const PageProvider = ({ children }) => {
  const AddWorkArray = useRef();
  const toaster = useToaster();
  const [searchParams] = useSearchParams();
  const id = searchParams.get("id");

  const getWorkQuery = useQuery({
    queryKey: ["works", id],
    queryFn: getTestById,
    enabled: !!id,
  });

  const getBlogBySlugQuery = useQuery({
    queryKey: ["blogs", id],
    queryFn: getTestById,
    enabled: id ? true : false,
  });

  const updateWorkQuery = useMutation({ mutationFn: udpateTest });
  const addWorkItemQuery = useMutation({ mutationFn: addTest });

  const initialValues = useMemo(() => {
    const workAddData = getWorkQuery?.data?.data || {};
    return {
      name: workAddData?.name || "",
      position: workAddData?.position || "",
      review: workAddData?.review || "",
    };
  }, [getWorkQuery]);

  const handleSubmit = async (values) => {
    const payload = {
      name: values?.name,
      position: values?.position,
      review: values?.review,
    };

    if (id) {
      payload.id = getBlogBySlugQuery?.data?.data?._id;
      updateWorkQuery.mutate(payload, {
        onSuccess: () => {
          toaster.success(Const.MESSAGES.SUCCESS, Const.MESSAGES.DATA_IS_UPDATED_SUCCESSFULLY);
        },
      });
      return;
    }
    addWorkItemQuery.mutate(payload, {
      onSuccess: () => {
        toaster.success(Const.MESSAGES.SUCCESS, Const.MESSAGES.DATA_IS_UPDATED_SUCCESSFULLY);
      },
    });
  };

  const handleNewWorkAdd = () => {
    AddWorkArray.current.push({ image_link: "" });
  };

  const handleNewWorkDelete = (index) => () => {
    AddWorkArray.current.remove(index);
  };
  return (
    <PageContext.Provider
      value={{
        initialValues,
        handleNewWorkDelete,
        AddWorkArray,
        handleNewWorkAdd,
        getWorkQuery,
        handleSubmit,
      }}
    >
      {children}
    </PageContext.Provider>
  );
};

export const useAddWorkProvider = () => {
  return useContext(PageContext);
};
